module.exports = __webpack_public_path__ + "static/img/2_3_3.7890e36e.jpg";